import { AdminInvites, AdminInvitesState } from './admin-invites';
import { SharedComputers, SharedComputersState } from './shared-computers';

interface CombinedState {
  adminInvites: AdminInvitesState;
  sharedComputers: SharedComputersState;
}

// Preserve the original runtime: the combined default state seeds each slice with
// an empty object (not the slices' own initial states). Each slice reducer supplies
// its own initial state via its default parameter when invoked with `undefined`.
const initialState: CombinedState = {
  adminInvites: {} as AdminInvitesState,
  sharedComputers: {} as SharedComputersState,
};

function CombinedReducer(
  state: CombinedState = initialState,
  action: { type: string; payload?: unknown },
): CombinedState {
  return {
    adminInvites: AdminInvites(
      state.adminInvites,
      action as Parameters<typeof AdminInvites>[1],
    ),
    sharedComputers: SharedComputers(
      state.sharedComputers,
      action as Parameters<typeof SharedComputers>[1],
    ),
  };
}
// Contine to export each individual reducer to also provide la carte menu.
// Consumer can then import either combined (AdminClientReducers.CombinedReducer)
// or individual (AdminClientReducers.AdminInvites).
export { AdminInvites, SharedComputers, CombinedReducer };
